/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown> }} Embed_Captions_Event_Missing_TextInputs */



/**
* | output |
* | --- |
* | "Event {index} has no text. Would you like to ABORT your export?" |
*
* @param {Embed_Captions_Event_Missing_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_event_missing_text = /** @type {((inputs: Embed_Captions_Event_Missing_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Event_Missing_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`L'evenement ${i?.index} n'a pas de texte.
 Souhaitez-vous ABANDONNER l'exportation ?`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Das Ereignis ${i?.index} enthält keinen Text.
Möchten Sie den Export abbrechen?`)
	if (locale === "it") return /** @type {LocalizedString} */ (`L'evento ${i?.index} non contiene testo.
Vuoi ANNULLARE l'esportazione?`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Событие ${i?.index} не содержит текста.
Вы хотите ОТМЕНИТЬ экспорт?`)
	if (locale === "es") return /** @type {LocalizedString} */ (`El evento ${i?.index} no tiene texto.
¿Desea cancelar la exportación?`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`事件 ${i?.index} 没有文本。

是否要中止导出？`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`イベント ${i?.index} にテキストがありません。
エクスポートを中止しますか?`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`इवेंट ${i?.index} में कोई टेक्स्ट नहीं है।
क्या आप अपना निर्यात रद्द करना चाहेंगे?`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`O evento ${i?.index} não possui texto.
Deseja CANCELAR a exportação?`)
	return /** @type {LocalizedString} */ (`Event ${i?.index} has no text.
 Would you like to ABORT your export?`)
});